import { ViewModel, View, ObservableArray } from "binder"
import { WorkingShiftManipulationView } from "./workingShiftManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader, TimeSelectorViewModel } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { IWorkingShift } from "./IWorkingShift";
import { WorkingShiftEditorViewModel, WorkingShiftInserter, WorkingShiftUpdater } from "./workingShiftEditor/workingShiftEditor-viewModel";
import moment from "moment";
import { TimePart } from "src/uicomponents/components/timeSelector/timeSelector-viewModel";

export class WorkingShiftManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف شیفت کاری';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.workingShifts = ObservableArray.create<WorkingShift>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh()
    }
    GetDefaultView(): View<ViewModel> {
        return new WorkingShiftManipulationView();
    }
    public getTypeId(): string {
        return "VM-02D6E34A-F2C3-45BD-9E85-ECD5B8F80897"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean; s
    public set workingShifts(v: ObservableArray<WorkingShift>) { this._workingShifts = v; } public get workingShifts(): ObservableArray<WorkingShift> { return this._workingShifts; } private _workingShifts: ObservableArray<WorkingShift>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WorkingShiftServices/ListAllWorkingShifts', {
                FilteringInformation: filteringInformation
            });
            this.workingShifts.update(...result.WorkingShifts.map((x, i) => {
                let workShift = new WorkingShift(this);
                workShift.index = i+1;
                workShift.id = x.Id;
                workShift.shiftName = x.Name;
                workShift.startTime = x.StartTime;
                workShift.endTime = x.EndTime;
                return workShift;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async addNew() {
        let popup = new WorkingShiftEditorViewModel(this, new WorkingShiftInserter());
        let result = await this.showPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async edit(workingShift: IWorkingShift) {
        let popup = new WorkingShiftEditorViewModel(this, new WorkingShiftUpdater());
        await workingShift.cloneTo(popup);
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async remove(workingShift: WorkingShift): Promise<void> {
        let isDeleted = await this.messageBoxDangerYesNo('آیا از حذف اطمینان دارید؟', 'حذف');
        if (isDeleted == 'yes') {
            try {
                let result = await ServerConnection.callServer("/Complex/WorkingShiftServices/DeleteWorkingShift", {
                    WorkingShiftId: workingShift.id,
                });
                if (result.IsSuccessful == true) {
                    await this.messageBoxConfirmSuccess("حذف با موفقیت انجام شد", "عملیات موفق");
                    this.dataLoader.refresh();
                } else {
                    if (result.Faults[0].Parameters.FaultId == 'D2BF392F-0EC9-4491-9DD3-FF7F3E096630') {
                        await this.messageBoxConfirmWarning("امکان حذف وجود ندارد", "خطا در عملیات");
                    }
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning("خطا در عملیات حذف", "خطا در عملیات");
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
}

export class WorkingShift extends ViewModel implements IWorkingShift {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: WorkingShiftManipulationViewModel) {
        super(parent);
        this._typedParent = parent;

    }

    private _typedParent: WorkingShiftManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set shiftName(v: string) { this._shiftName = v; } public get shiftName(): string { return this._shiftName; } private _shiftName: string;
    public set startTime(v: moment.Moment) { this._startTime = moment.utc(v); } public get startTime(): moment.Moment { return this._startTime;} private _startTime: moment.Moment;
    public set endTime(v: moment.Moment) { this._endTime = moment.utc(v); } public get endTime(): moment.Moment { return this._endTime;} private _endTime: moment.Moment;
    

    async cloneTo(workingShift: IWorkingShift) {
        workingShift.id = this.id;
        workingShift.shiftName = this.shiftName;
        workingShift.startTime = this.startTime;
        workingShift.endTime = this.endTime;
    }

    async edit() {
        this._typedParent.edit(this);
    }

    async remove(): Promise<void> {
        this._typedParent.remove(this);
    }
}
